import { render, staticRenderFns } from "./index.vue?vue&type=template&id=70302bed"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70302bed')) {
      api.createRecord('70302bed', component.options)
    } else {
      api.reload('70302bed', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=70302bed", function () {
      api.rerender('70302bed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BjRegionCascader/index.vue"
export default component.exports